import React, { useState, useEffect } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const DropdownMenu = ({ data, selectedItem, onSelect, placeholder, setFieldTouched }) => {
  const [open, setOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");

  useEffect(() => {
    const match = data.find((item) => item.value === selectedItem);
    setSelectedLabel(match ? match.label : "");
  }, [selectedItem, data]);

  const handleSelect = (item) => {
    onSelect(item.value);
    setSelectedLabel(item.label);
    setFieldTouched("skill");
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full flex justify-between text-left px-3 py-2 border border-gray-300 rounded bg-white text-sm font-[Gilroy-Regular] text-[#0D1C2E]"
      >
        <span>{selectedLabel || placeholder}</span>
        {open? 
          <KeyboardArrowUpIcon fontSize="small" />:
          <KeyboardArrowDownIcon fontSize="small" />
        }
      </button>
      {open && (
        <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded shadow">
          {data.map((item) => (
            <li
              key={item.value}
              onClick={() => handleSelect(item)}
              className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 text-[#0D1C2E]"
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default  DropdownMenu;